import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App.tsx';
import { ThemeProvider } from '@/theme.tsx';
import '@/styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('console: #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
